import { storage } from "@/CommonDP/utils";
import { isDef } from "@/CommonDP/utils/common";
import globalParams from '@/CommonDP/utils/globalParams.js';
import env from '@/CommonDP/utils/env';

export function getContextPath() {
  return env.VUE_APP_API;
}
export function scanUrl(fileId, version, sharerId = "") {
  if (getToken()) {
    return location.origin + getContextPath() + `/wopi/download/file/content?fileId=${fileId}&version=${version}&token=${getToken()}`;
  } else {
    return location.origin + getContextPath() + `/doc/share/download/file/content?fileId=${fileId}&version=${version}&sharerId=${sharerId}`;
  }
}
export function scanHlsUrl(url) {
  return location.origin + getContextPath() + '/hls/' + url;
}
// 文件预览-免登录
export function loginFreescanUrl(fileId, version) {
  return location.origin + getContextPath() + `/doc/share/download/file/content?fileId=${fileId}&version=${version}`;
}

export function viewOfficeUrl(fileId) {
  return location.origin + getContextPath() + `/wopi/getWopiClientUri?fileId=${fileId}&isEdit=false&token=${getToken()}`;
}

export function questionImgUrl1(fileMD5) {
  return location.origin + getContextPath() + `/pic/preview/${fileMD5}?token=${getToken()}` ;
}
// 批注截图预览地址（新）
export function questionImgUrlNew(fileMd5, fileId, fileVersion) {
  return location.origin + getContextPath() + `/pic/newPreview?fileMd5=${fileMd5}&fileId=${fileId || ''}&fileVersion=${fileVersion || 1}&token=${getToken()}` ;
}

export function downloadUrltoken(prjId, fileId, userIdS, versionS) {
  const userId = userIdS || "";
  const version = versionS || "";
  // 自定义接口地址
  const newUrl = globalParams.get("url:/doc/download/${prjId}/${fileId}");
  if (isDef(newUrl)) {
    return location.origin + getContextPath() + `${newUrl}/${prjId}/${fileId}?userId=${userId}&version=${version}&token=${getToken()}`;
  }
  return location.origin + getContextPath() + `/doc/download/${prjId}/${fileId}?userId=${userId}&version=${version}&token=${getToken()}`;
}

export function getToken() {
  return storage.get('token') || "";
}

export async function getShareToken() {
  const res = await mongeService.createShareToken();
  return res.data;
}

export function is3DModel(fileType) {
  return fileType === 7 || fileType === 18 || fileType === 19 || fileType === 22 || fileType === 23 || fileType === 51;
}

// 简单实现防抖
export const debounce = (callback, delay = 500) => {
  let timer;
  return function () {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      callback.call(this, ...arguments);
    }, delay);
  };
};
// 是不需要轻量化的模型
export function isNoLightweightModel(fileType) {
  return Number(fileType) === 24 || Number(fileType) === 43 || Number(fileType) === 44;
}

// export function noLightweightUrl(prjId, fileId, version, sharerId = "") {
//   if (getToken()) {
//     return location.origin + getContextPath() + `/doc/download/${prjId}/${fileId}?version=${version || ""}&token=${getToken()}`;
//   } else {
//     return location.origin + getContextPath() + `/doc/shareNew/file/download?fileId=${fileId}&version=${version}&shareToken=${sharerId}`;
//   }
//   // if (version) {
//   // } else {
//   //   return location.origin + getContextPath() + `/doc/download/${prjId}/${fileId}?token=${getToken()}`;
//   // }
// }
/**
 * 生成水印用户信息
 * @returns {string}
 */
export function creatWatermarkUserInfo() {
  const store = require("@/store/index").default;
  const { name } = store.state.user;

  const user = store.state.userInfo || {};
  const date = new Date();
  const current_date = date.getDate();
  const current_month = date.getMonth() + 1;
  const current_year = date.getFullYear();
  const watermarkUserInfo = `${name}${user.userName ? `(${user.userName})` : ""}${current_year}-${current_month}-${current_date}`;
  return watermarkUserInfo;
}
/**
 * 指定DOM添加水印
 * @param containerEle  指定DOM
 * @param waterText     水印内容
 */
export function addWaterMarker(containerEle, waterText) {
  console.log("设置明水印", containerEle, waterText);
  waterText = waterText || "禁止外传";
  // 水印图案
  const canvas = document.createElement("canvas");
  canvas.id = "canvas";
  canvas.width = "400"; // 单个水印的宽高
  canvas.height = "160";
  const ctx = canvas.getContext("2d");
  ctx.font = "normal 15px Microsoft Yahei"; // 设置样式
  ctx.fillStyle = "rgba(214,228,213,0.4)"; // 水印字体颜色
  ctx.rotate((-30 * Math.PI) / 180); // 水印偏转角度
  ctx.fillText(waterText, -50, 100);
  const src = canvas.toDataURL("image/png");
  // 水印容器
  const maskDiv = document.createElement("div");
  maskDiv.style.position = "absolute";
  maskDiv.style.zIndex = "0";
  maskDiv.id = "_waterMark";
  maskDiv.style.top = "0px";
  maskDiv.style.left = "0px";
  maskDiv.style.width = "100%";
  maskDiv.style.height = "100%";
  maskDiv.style.marginTop = 0;
  maskDiv.style.pointerEvents = "none";
  maskDiv.style.backgroundImage = "URL(" + src + ")";
  // 水印节点插到指定id下
  containerEle.appendChild(maskDiv);
}
// 清除水印
export function clearWaterMarker(containerEle){
  let childElement = document.getElementById("_waterMark");
  containerEle.removeChild(childElement);
}
export function uniqueSortedArray(array) {
  if (!array || !array.length) {
    return [];
  }
  let head = 0;
  let tail = 0;
  while (head < array.length) {
    while (++head < array.length && array[head] === array[tail]) {
      continue;
    }
    if (head >= array.length) {
      break;
    }
    array[++tail] = array[head];
  }
  return array.slice(0, tail + 1);
}
